import { useState, useEffect, useCallback } from "react";
import { apiClient } from "../services/api";
import type { TemplatesListResponse, TemplatesListRequest } from "../types/api";

export function useTemplates(page: number = 1, perPage: number = 12) {
  const [templates, setTemplates] = useState<TemplatesListResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTemplates = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const request: TemplatesListRequest = {
        page,
        per_page: perPage,
      };

      const response = await apiClient.getTemplates(request);
      setTemplates(response);
    } catch (err: any) {
      setError(err instanceof Error ? err.message : "Failed to fetch templates");
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  return {
    templates,
    loading,
    error,
    refetch: fetchTemplates,
  };
}
